import React from 'react'
import { Link } from 'react-router-dom'
import { Label } from '@mailstep/design-system/ui/Elements/Label'
import styled from '@xstyled/styled-components'
import { Paragraph4 } from '@mailstep/design-system/ui/Elements/Typography'
import { Trans } from '@lingui/react'
import { InboundReceipt } from '@typings/entities/InboundReceipt'
import { DateTime } from 'luxon'
import routes from '@pages/index'
import HighlightBox from '@components/elements/HighlightBoxReworked'

const Wrapper = styled.div`
  margin-top: 0;
  width: 100%;
  label {
    font-size: 12px;
    margin-left: 0;
  }
  @media (min-width: 768px) {
    margin-top: 2;
  }
`

const StyledWrap = styled(Paragraph4)`
  display: flex;
  gap: 10px;
  text-decoration: underline;
  flex-wrap: wrap;
`

interface Props {
  list?: InboundReceipt[]
}

const Receipts = ({ list = [] }: Props): JSX.Element => {
  return (
    <Wrapper>
      <Label>
        <Trans id="form.receiptList.heading" message="List of Receipts" />
      </Label>
      <StyledWrap>
        {list.map((item, index) => (
          <Link key={`${item}-${index}`} to={routes.sharedInboundReceipt.route.toUrl({ id: item.id })}>
            <HighlightBox appearance="blueSubtle" size="default">
              {DateTime.fromISO(item.createdAt).toFormat('dd.MM.yyyy')} -{' '}
              {item.wmsInternalId || <Trans id="form.receiptList.errorMissing" message="WMS id missing" />}
            </HighlightBox>
          </Link>
        ))}
      </StyledWrap>
    </Wrapper>
  )
}
export default Receipts
